<template>
  <v-col cols="12" xl="6">
    <v-container fluid data-cy="panel-demobikes">
      <v-row no-gutters>
        <v-col>
          <div class="stats-title">
            <h3>{{ $t(title) }}</h3>
            <v-tooltip
              v-if="tooltip"
              bottom
              :max-width="400"
              nudge-right="100%"
              transition="fade-transition"
              content-class="tooltip-content">
              <template v-slot:activator="{on, attrs}">
                <v-icon class="fa-light fa-circle-info click" color="tertiary" dense v-on="on" v-bind="attrs" />
              </template>
              <span v-html="$t(tooltip)"></span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6" lg="4">
          <CardGauge
            :loading="loading"
            :data-testid="$t('honda.dashboard.stats.demo-bikes.fleet')"
            :title="$t('honda.dashboard.stats.demo-bikes.fleet')"
            :current="data.demoBikes"
            :percent="data.demoBikesPerc"
            :target="data.demoBikesTarget"
            :status="data.demoBikesStatus" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardTrend
            :data-testid="$t('honda.dashboard.stats.demo-bikes.transfers')"
            :loading="loading"
            :title1="$t('honda.dashboard.stats.demo-bikes.transfers')"
            :value1="data.loans"
            :percent="data.loansYoy"
            :title2="$t('honda.dashboard.stats.demo-bikes.transfers-demo-bikes')"
            :value2="data.loanedDemoBikes"
            :year="data.year" />
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <CardGauge50
            v-if="sectionLoansSales"
            :loading="loading"
            :title="$t('honda.dashboard.stats.demo-bikes.transfers-sales')"
            :percent="data.loansSalesPerc"
            :target="data.loansSalesTarget" />
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script lang="ts">
import {defineComponent} from '@vue/composition-api'

import CardGauge from '@/components/metrics/CardGauge.vue'
import CardGauge50 from '@/components/metrics/CardGauge50.vue'
import CardTrend from '@/components/metrics/CardTrend.vue'

export default defineComponent({
  name: 'StatsDemoBikes',
  components: {
    CardGauge,
    CardGauge50,
    CardTrend,
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    sectionLoansSales: {
      type: Boolean,
      required: false,
    },
  },
})
</script>
